import { clsx } from 'clsx';
import type { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Case-insensitive comparator for object properties.
 *
 * Note: Uses nullish coalescing (??) to handle potentially undefined properties.
 * While T extends Record<string, string>, TypeScript treats bracket notation access
 * as possibly undefined since it can't guarantee the property exists at runtime.
 * Missing properties are treated as empty strings for comparison purposes.
 */
export function objComparatorICase<T extends Record<string, string | undefined>>(
  a: T,
  b: T,
  property: keyof T,
): number {
  return comparatorICase(a[property] ?? '', b[property] ?? '');
}

export function comparatorICase(a: string, b: string) {
  const keyA = a.toUpperCase();
  const keyB = b.toUpperCase();
  return (
    keyA < keyB ? -1
    : keyA > keyB ? 1
    : 0
  );
}
